import i18n from '@/i18n';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/zh';
import { useTranslation } from 'react-i18next';
import { useSnapshot } from 'valtio';

import { Box, MenuItem, Select } from '@mui/material';

import {
  DatePicker,
  DateTimeField,
  LocalizationProvider,
} from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import { FeftchSpan, setFetchSpan, setFetchStart, store } from '../../store';

export function DateRangeFilter() {
  const { fetchLimits, tsFetchRange, fetchSpan } = useSnapshot(store);
  const { t } = useTranslation();
  const currentLocale = i18n.language;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={currentLocale}
    >
      <Box display="flex" gap={2} alignItems="center">
        {/* Picker pour la date de début */}
        <Box>
          <DatePicker
            label={t('reeferInsights.dateRangeFilter.startDate')}
            value={tsFetchRange ? dayjs(tsFetchRange[0]) : null}
            views={['month', 'year']}
            openTo="month"
            disableFuture
            format="MMM YYYY"
            onChange={(newValue) => {
              if (newValue) {
                console.log('newValue', newValue);
                setFetchStart(dayjs(newValue));
              }
            }}
            minDate={
              fetchLimits ? dayjs(fetchLimits[0].valueOf()) : fetchLimits
            }
            maxDate={
              fetchLimits ? dayjs(fetchLimits[1].valueOf()) : fetchLimits
            }
          />
        </Box>

        {/* Picker pour la date de fin */}
        <Box>
          <DateTimeField
            label={t('reeferInsights.dateRangeFilter.endDate')}
            value={tsFetchRange ? dayjs(tsFetchRange[1]) : null}
            format="MMM YYYY"
          />
        </Box>

        {/* Sélection de l'intervalle */}
        <Box>
          <Select
            value={fetchSpan}
            onChange={(event) => setFetchSpan(event.target.value as FeftchSpan)}
            displayEmpty
          >
            <MenuItem value={FeftchSpan.WEEK}>
              {t('reeferInsights.dateRangeFilter.oneWeek')}
            </MenuItem>
            <MenuItem value={FeftchSpan.MONTH}>
              {t('reeferInsights.dateRangeFilter.oneMonth')}
            </MenuItem>
            <MenuItem value={FeftchSpan.MONTH_3}>
              {t('reeferInsights.dateRangeFilter.threeMonths')}
            </MenuItem>
            <MenuItem value={FeftchSpan.MONTH_6}>
              {t('reeferInsights.dateRangeFilter.sixMonths')}
            </MenuItem>
          </Select>
        </Box>
      </Box>
    </LocalizationProvider>
  );
}
